import React from 'react';

const loginLayout = props => {
  const { children } = props;
  return <div>{children}</div>;
};

export default loginLayout;
